"use client";

import { MantineProvider } from "@mantine/core";
import NextTopLoader from "nextjs-toploader";
import { useEffect } from "react";
import { Provider } from "react-redux";

import { store } from "@/store";

export default function Providers({ children }: { children: React.ReactNode }) {
  // Break out of iframes (moved from the old _app.tsx)
  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      window.top &&
      window.self &&
      window.top !== window.self
    ) {
      window.top.location.href = window.self.location.href;
    }
  }, []);

  return (
    <Provider store={store}>
      <MantineProvider>
        {children}
        <NextTopLoader color="#f26e21" />
      </MantineProvider>
    </Provider>
  );
}
